import { LookupModel } from './lookup-model';

export class VariableModel extends LookupModel{
  variableId: number;
  description: string;
  startDate: Date;
  endDate: Date;
  values: [{valueId: number, variableId: number, description: string}]
}